
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import { GoCheck } from "react-icons/go";
import { CopyToClipboard } from 'react-copy-to-clipboard';

import CustomHorizontalScroll from "../../common/CustomHorizontalScroll";

import { IoWarningOutline, IoShareSocialSharp } from "react-icons/io5";
import { FiLink } from "react-icons/fi";
import { BiLoaderCircle } from "react-icons/bi";
import { MdOutlineOfflineBolt, MdDoNotDisturb, MdOutlineKeyboardArrowRight } from "react-icons/md";

import { AmbassadorSendInvite, ConnectImpactAccount } from "../../redux/v2/user/actions";
import { GetPrograms } from "../../redux/v2/program/actions";

import { isValidEmail, isValidNumber } from "../../utils";
import { delay } from "../../utils";

import "./style.css"

function Ambassador(props) {

   const { account } = props.User;
   const { programs } = props.Program;

   const [link, setLink] = useState("");
   const [method, setMethod] = useState("email");
   const [status, setStatus] = useState(1);
   const [hasInvite, setHasInvite] = useState(false);
   const [isFormComplete, setIsFormComplete] = useState(false);
   const [connectionStage, setConnectionStage] = useState(1);
   const [connectionStatus, setConnectionStatus] = useState(1);
   const [isShowClipboard, setIsShowClipboard] = useState(false);
   const [programList, setProgramList] = useState([]);
   const [selectedProgram, setSelectedProgram] = useState(false);

   const [details, setDetails] = useState({
      firstName: "",
      lastName: "",
      email: "",
      number: "",
      message: "",
   })

   const adIDs = {
      signup: process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_IMPACT_SIGNUP : process.env.REACT_APP_IMPACT_SIGNUP_DEV,
      homepage: process.env.REACT_APP_IMPACT_HOMEPAGE,
   }

   let defaultMessage = `Share encouragement or directions on your invitation.`;

   useEffect(() => {
      props.GetPrograms();
   }, []);

   useEffect(() => {

      let temp = [];

      for (let x = 0; x < programs.length; x++) {
         if (programs[x].beginner) {
            temp.push({
               name: programs[x].title + " Beginner",
               id: programs[x].id,
               intro: programs[x].beginner,
               image: programs[x].thumbnail.replace("type", "beginner"),
               isSelected: false,
            })
         }

         if (programs[x].moderate) {
            temp.push({
               name: programs[x].title + " Moderate",
               id: programs[x].id,
               intro: programs[x].moderate,
               image: programs[x].thumbnail.replace("type", "moderate"),
               isSelected: false,
            })
         }

         if (programs[x].advanced) {
            temp.push({
               name: programs[x].title + " Advanced",
               id: programs[x].id,
               intro: programs[x].advanced,
               image: programs[x].thumbnail.replace("type", "advanced"),
               isSelected: false,
            })
         }

         if (!programs[x].beginner && !programs[x].moderate && !programs[x].advanced) {
            temp.push({
               name: programs[x].title,
               id: programs[x].id,
               intro: programs[x].info,
               image: programs[x].thumbnail,
               isSelected: false,
            })
         }
      }

      setProgramList(temp);

   }, [programs]);

   const onChangeDetails = (e, field) => {
      setIsFormComplete(false);

      let tempDetails = {
         ...details,
         [field]: e.target.value
      }

      setDetails({
         ...tempDetails
      });

      if (
         (tempDetails.firstName && tempDetails.firstName.length > 2) &&
         (tempDetails.lastName && tempDetails.lastName.length > 2) &&
         (
            (
               method == "email" &&
               isValidEmail(tempDetails.email)
            ) ||
            (
               method == "text" &&
               isValidNumber(tempDetails.number)
            )
         )
      ) {
         setIsFormComplete(true);
      }
   };

   const sendInvite = async () => {
      const toastId = toast.loading("Sending Invitation...");

      let selectedProgram = programList.filter(({ isSelected }) => isSelected);
      const link = `https://indi.pxf.io/c/${account?.user?.impact_id}/${adIDs["signup"]}/${process.env.REACT_APP_IMPACT_CAMPAIGN_ID}`;

      let payload = {
         ...details,
         message: details.message || `Hi ${details.firstName}, here's a link to join indi and a recommended program to get started with!`,
         selectedProgram: selectedProgram,
         link: link,
      }


      const res = await props.AmbassadorSendInvite(payload);
      if (res.success) {
         setDetails({
            firstName: "",
            lastName: "",
            email: "",
            number: "",
            message: "",
         });

         setSelectedProgram([]);

         toast.success('Invitation Sent!', {
            id: toastId,
         });

         setStatus(1);

      } else {
         toast.error(res.msg, {
            id: toastId,
         });
      }

   };

   const InviteOption = ({ type, title, icon, action }) => {

      const link = `https://indi.pxf.io/c/${account?.user?.impact_id}/${adIDs[type]}/${process.env.REACT_APP_IMPACT_CAMPAIGN_ID}`

      return (
         <div className='nav-menu-group-link' onClick={action}>
            <div>
               {icon}
               <CopyToClipboard text={link}
                  onCopy={() => {
                     setIsShowClipboard(true);
                     delay(() => {
                        setIsShowClipboard(false);
                     }, 3000);
                  }}>
                  <span>{title}</span>
               </CopyToClipboard>
            </div>
            <div><MdOutlineKeyboardArrowRight /></div>
         </div>
      );
   }

   let connected = account?.user?.impact_id;

   return (
      <div style={{ paddingTop: '1px' }}>

         <div className="flex-c">
            <div id="ambassador-program" className="page-content-v2">

               {
                  status === 1 && <>
                     <p className="hd-1" style={{ marginTop: "20px" }}>
                        Help get the world moving and earn in the process!
                     </p>

                     {
                        connected
                           ? <span className="connected-status">
                              STATUS: <span style={{ marginLeft: "8px" }}> <MdOutlineOfflineBolt style={{ fontSize: "20px", marginTop: "-4px" }} /> CONNECTED</span>
                           </span>
                           : <span className="error-status-1">
                              STATUS: <span style={{ marginLeft: "8px" }}> <MdDoNotDisturb style={{ fontSize: "20px", marginTop: "-4px" }} /> DISCONNECTED</span>
                           </span>
                     }

                     {
                        connected
                           ? <div id="share-options">
                              <div className='nav-menu-group-links-items'>

                                 <InviteOption title="Send Invite" icon={<IoShareSocialSharp />} action={() => {
                                    setStatus(2);
                                 }} />

                                 <InviteOption type="signup" title="Copy Sign Up Link" icon={<FiLink />} action={() => {
                                 }} />

                                 <InviteOption type="homepage" title="Copy Homepage Link" icon={<FiLink />} action={() => {
                                 }} />

                              </div>

                              {
                                 isShowClipboard &&
                                 <div className="flex-c" style={{ width: "100%" }}>
                                    <div className="copy-prompt">
                                       <GoCheck />
                                       <span> Your link copied to the clipboard.</span>
                                    </div>
                                 </div>
                              }
                           </div>
                           : <>
                              <button className="connect-account-btn" onClick={async () => {
                                 if (connectionStage === 1) {
                                    setConnectionStatus(1);
                                    setConnectionStage(2);
                                    const res = await props.ConnectImpactAccount();

                                    if (res.success) {
                                       setConnectionStage(1);
                                    } else {
                                       setConnectionStage(1);
                                       setConnectionStatus(0);
                                    }
                                 }
                              }}>
                                 {
                                    connectionStage == 1 // 1 is plain 2 is loading
                                       ? <>
                                          <MdOutlineOfflineBolt />
                                          CONNECT ACCOUNT
                                       </>
                                       : <>
                                          CONNECTING...
                                          <BiLoaderCircle className="btn-loading" style={{ marginLeft: "10px" }} />
                                       </>
                                 }
                              </button><br />


                              {
                                 connectionStatus === 0 &&
                                 <span className="error-status-2">
                                    <IoWarningOutline /><br />
                                    Connection Failed. Please log out and log back into your indi account and try again.<br />
                                    If the error persists, contact<br />
                                    support@indimoves.com for assistance<br />
                                 </span>
                              }
                           </>
                     }

                  </>
               }

               {
                  status === 2 &&
                  <div id="po-c-send-invite-form">
                     <p>Send Invite</p>
                     {/* <span>Help get the world moving and earn passive income in the process!</span> */}
                     <div id="invite-details" style={{ marginTop: "-6px" }}>
                        <span>Help get the world moving and earn passive income in the process!</span>
                     </div>

                     <div id="invite-method">
                        <button className={method === "email" ? "active" : ""} onClick={() => setMethod("email")}>EMAIL</button>
                        {/* <button className={method === "text" ? "active" : ""} onClick={() => setMethod("text")}>TEXT</button> */}
                     </div>

                     <div id="invite-details">
                        <span>Their Details</span>
                        <input type="text" placeholder="First Name" value={details.firstName} onChange={(e) => onChangeDetails(e, "firstName")} />
                        <input type="text" placeholder="Last Name" value={details.lastName} onChange={(e) => onChangeDetails(e, "lastName")} />

                        {method === "email" &&
                           <input type="email" placeholder="Email Address" value={details.email} onChange={(e) => {
                              onChangeDetails(e, "email");
                              if (details.number) {
                                 onChangeDetails({ target: { value: "" } }, "number")
                              }
                           }} />
                        }

                        {method === "text" &&
                           <input type="number" placeholder="(555) 555-5555" value={details.number} onChange={(e) => {
                              if (e.target.value.length < 11) {
                                 onChangeDetails(e, "number");
                                 if (details.email) {
                                    onChangeDetails({ target: { value: "" } }, "email")
                                 }
                              }
                           }} />
                        }

                     </div>

                     <button disabled={!isFormComplete} className="invite-button" onClick={() => setStatus(3)}>NEXT</button>

                  </div>
               }

               {
                  status === 3 && <>

                     <div id="po-c-send-invite-form" style={{ padding: "0 30px" }}>
                        <p style={{ marginBottom: 0 }}>Send Invite</p>

                        <div id="invite-details" style={{ marginTop: "10px" }}>
                           <span>Help get the world moving and earn passive income in the process!</span>
                        </div>

                        <div id="invite-details" className="invite-programs-carousel-wrapper" style={{ marginTop: "10px", textAlign: "left" }}>
                           <span style={{ fontSize: "13px" }}>Recommend a Program</span>

                           <CustomHorizontalScroll className="invite-programs-carousel">

                              {
                                 programList.map(({ id, name, isSelected }) => {
                                    return (
                                       <div key={"amb-pl-" + id} className={`ipc-tile ${isSelected ? "selected" : ""}`}
                                          onClick={() => {

                                             let temp = [...programList];

                                             for (let x = 0; x < temp.length; x++) {
                                                temp[x] = {
                                                   ...temp[x],
                                                   isSelected: name === temp[x].name
                                                }
                                             }

                                             setSelectedProgram(true);
                                             setProgramList(temp);

                                          }}
                                       >
                                          <span>{name}</span>
                                       </div>
                                    )
                                 })
                              }

                           </CustomHorizontalScroll>
                        </div>

                        <div id="invite-details" style={{ marginTop: "10px", textAlign: "left" }}>
                           <span style={{ fontSize: "13px" }}>Write a personal message (optional)</span>
                           <textarea type="text" placeholder={defaultMessage} value={details.message} onChange={(e) => onChangeDetails(e, "message")} />
                        </div>

                        <div className="invite-buttons">
                           <button className="invite-button" onClick={() => setStatus(2)}>BACK</button>
                           <button className="invite-button" disabled={!selectedProgram} onClick={() => {
                              sendInvite();
                           }}>SEND</button>
                        </div>
                     </div>
                  </>
               }

            </div>
         </div>



      </div>
   );
}

const mapStateToProps = (state) => ({
   User: state.User,
   Program: state.Program,
});

export default connect(mapStateToProps, {
   AmbassadorSendInvite,
   ConnectImpactAccount,
   GetPrograms,
})(Ambassador);